import React, { memo, ReactNode, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { PercentLoaderIcon } from '../../assets/icons/PercentLoaderIcon';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './DropdownItem.scss';
const rootClassName = 'component-dropdown-item';

interface DropdownItemProps {
  id?: string;
  icon?: ReactNode;
  label?: string;
  disabled?: boolean;
  onClick?: (event?: any) => void;
  alignRight?: boolean;
  loading?: boolean;
}

function DropdownItem(props: DropdownItemProps) {
  const classNames = useMemo(() => {
    return getMergedClassNames([
      rootClassName,
      props.alignRight ? 'right' : '',
      props.loading ? 'loading' : '',
    ]);
  }, [props.alignRight, props.loading]);

  return (
    <button
      id={props.id}
      disabled={props.disabled}
      aria-disabled={props.disabled}
      className={classNames}
      onClick={(evt) => {
        if (
          typeof props.onClick === 'function' &&
          !props.loading &&
          !props.disabled
        ) {
          props.onClick(evt);
        }
      }}
    >
      <div className={`${rootClassName}-content`}>
        <CSSTransition
          in={props.loading}
          timeout={300}
          unmountOnExit
          classNames={`${rootClassName}-fade`}
        >
          <div className={`${rootClassName}-loader`}>
            <PercentLoaderIcon indefinido />
          </div>
        </CSSTransition>
        {props.icon ? (
          <div className={`${rootClassName}-icon`}>{props.icon}</div>
        ) : undefined}
        <div className={`${rootClassName}-label`}>{props.label}</div>
      </div>
    </button>
  );
}

export default memo(DropdownItem);
